import { scrollToBottom } from "../utils.js";
function run() {
    $(() => {
        scrollToBottom('#errorlog');
    });
}
export const page_errors = {
    requiresAuth: true,
    run: run,
};
//# sourceMappingURL=errors.js.map